
<script>
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import ActionCountElement
  from "%/dynamic-component-editor/standard-elements/action-element/ActionCountElement.vue";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import { countToShow, isCountShown } from "%/dynamic-component-editor/helpers/story-engagement.mjs";
import HideCountAtZero from "%/dynamic-component-editor/options/hide-count-at-zero";
import ButtonActionCountOptions from "%/dynamic-component-editor/bundles/button-action-count-options";
import { ENGAGEMENT_ICONS } from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";

export default {
  name: "LikeCount",
  elementPanelSettings: {
    displayName: "Like Count",
    displayIcon: "material-symbols:filter-1-outline",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: ActionCountElement,
  mixins: [StoryPageElementMixin],
  options: [
    new HideCountAtZero({ default: true }),
  ],
  optionBundles: [
    new ButtonActionCountOptions({ "default.icon": ENGAGEMENT_ICONS.like, "default.display-icon": "hide" }),
  ],
  computed: {
    ...mapState(useConfigurationStore, [
      "canLikePosts",
    ]),
    shouldShowAction() {
      return isCountShown({
        editMode: this.editMode,
        featureOn: this.canLikePosts,
        count: this.entity.numLikes,
        hideAtZero: this.getOptionValue(HideCountAtZero),
      });
    },
    myValue() {
      return countToShow(this.entity.numLikes, this.getOptionValue(DisplayValue));
    },
  },
  methods: {
    handleClick() {
      window.location.href = `${this.links.web}/story/${this.entity.storyId}`;
    },
  },
};
</script>
